import { FC, useEffect } from 'react';
import { useLocation } from 'react-router';
import { DateTime } from 'luxon';
import { useSelector, useDispatch, usePrevious } from '~Hooks';
import * as actions from '~actions';
import { useStorage } from '~Components/Storage';
import { useMetadata } from '~Hooks/useMetadata';

/** If staffIdleTimeout is set: Logs staff out after a period of inactivity */
const StaffIdleTimeout: FC = (): null => {
  const location = useLocation();
  const [, , venueId] = location.pathname.split('/');
  const isInVenue = window.location.hash.includes('/venue/') && !!venueId;

  const timeOfLastAction = useSelector((state) => state.timeOfLastAction);
  const staffId = useSelector((state) => state.staff?.id);
  const company = useSelector((state) => state.company);

  const previousCompany = usePrevious(company);
  const [storage] = useStorage();
  const metadata = useMetadata();

  const dispatch = useDispatch();

  // Timeout staff while idling is staffIdleTimeout is set
  useEffect(() => {
    const timeout = setInterval(() => {
      if (
        !staffId ||
        !metadata.data.staffIdleTimeout ||
        !isInVenue ||
        storage.disableStaffTimeout
      ) {
        clearInterval(timeout);
        return;
      }

      if (
        DateTime.fromJSDate(timeOfLastAction).plus({ seconds: metadata.data.staffIdleTimeout }) <
        DateTime.now()
      ) {
        dispatch(actions.staffLogout());
        return;
      }
    }, 5000);
    return () => clearInterval(timeout);
  }, [staffId, timeOfLastAction, metadata.data.staffIdleTimeout]);

  // Logout staff if company changes
  useEffect(() => {
    if (company !== previousCompany) {
      dispatch(actions.staffLogout());
    }
  }, [company, previousCompany]);

  return null;
};

export default StaffIdleTimeout;
